module.exports = __webpack_public_path__ + "static/media/provider.ccc063f0.svg";